// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/loginBackgroundImage2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: "Open Sans", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.login_wrapper{
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center center;
  /* background-image: url("../src/assets/loginBackgroundImage2.png") */
}

.login-card {
  z-index: 1; 
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,+CAA+C;EAC/C,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,yDAAgE;AAClE;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,kCAAkC;EAClC,qEAAqE;AACvE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;aACW;AACb","sourcesContent":["body {\n  margin: 0;\n  font-family: \"Open Sans\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: 100%;\n  height: 100%;\n  background-image: url(\"../src/assets/loginBackgroundImage2.png\");\n}\n.login_wrapper{\n  background-size: 100% 100%;\n  background-repeat: no-repeat;\n  background-position: center center;\n  /* background-image: url(\"../src/assets/loginBackgroundImage2.png\") */\n}\n\n.login-card {\n  z-index: 1; \n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
